import { library, dom } from '@fortawesome/fontawesome-svg-core'

import {faFacebook, faTwitter, faXTwitter, faInstagram, faYoutube, faTiktok, faBluesky } from '@fortawesome/free-brands-svg-icons'

// import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch'
// import { faFileArchive } from '@fortawesome/free-solid-svg-icons/faFileArchive'
// import { faDownload } from '@fortawesome/free-solid-svg-icons/faDownload'
// import { faGithub } from '@fortawesome/free-brands-svg-icons/faGithub'

library.add(
  faFacebook,
  faTwitter,
  faXTwitter,
  faInstagram,
  faYoutube,
  faTiktok,
  faBluesky,
)

dom.watch()